<template>
  <single-function-layout @close="goToOrders" class="copy-orders" :loading="loading">
    <div>
      <div class="header">
        <h1>{{ $t('copyOrders.title') }}</h1>
      </div>
      <div class="body">
        <p>{{ numberOfOrdersSelected | formatNumber }} {{ $t('copyOrders.order') | determinePlural(numberOfOrdersSelected) }} {{ $t('copyOrders.selected') }}</p>
        <sb-radio-buttons
          v-if="isAdmin"
          :selectionOptions="invoicingTypes"
          v-model="invoicingOption"
        ></sb-radio-buttons>
      </div>
      <div class="footer">
        <a href="#" @click.prevent="goToOrders">{{ $t('copyOrders.actions.cancel') }}</a>
        <button class="btn btn-primary" @click.prevent="copyOrders">{{ $t('copyOrders.actions.execute') | determinePlural(numberOfOrdersSelected) }}</button>
      </div>
    </div>
  </single-function-layout>
</template>

<script>
import SingleFunctionLayout from '@/components/layouts/SingleFunction'
import { OrdersEnum } from '@enums/modules/routes'
import { InvoicingOptionsEnum } from '@enums/modules/orders/invoicingOptions'
import { promisePipe } from '@utils/functionalBob'
import { debounce } from 'lodash'

export default {
  name: 'CopyOrders',
  components: {
    'single-function-layout': SingleFunctionLayout
  },
  data: () => ({
    invoicingOption: InvoicingOptionsEnum.DefaultInvoiceAtClientCost,
    loading: false
  }),
  computed: {
    numberOfOrdersSelected () {
      if (this.allOrdersSelected) return this.$shipBobStore.getters['orders/pagination'].totalCount
      return this.$shipBobStore.getters['orders/flattenedSelectedOrderIds'].length
    },
    isAdmin () {
      return this.$shipBobStore.getters['user/getUser'].isAdmin
    },
    invoicingTypes () {
      return [
        {
          id: 1,
          value: InvoicingOptionsEnum.DefaultInvoiceAtClientCost,
          displayValue: this.$i18n.t('copyOrders.selections.default')
        },
        {
          id: 2,
          value: InvoicingOptionsEnum.DoNotInvoice,
          displayValue: this.$i18n.t('copyOrders.selections.doNotInvoice')
        }
      ]
    }
  },
  methods: {
    copyOrders: debounce(async function () {
      const toggleLoader = (on) => (val) => {
        this.loading = on
        return val
      }
      const copy = promisePipe(
        toggleLoader(true),
        async (invoicingOption) => await this.$shipBobStore.dispatch('orders/copyOrders', invoicingOption),
        toggleLoader(false)
      )
      const success = await copy(this.invoicingOption)
      if (success) {
        this.goToOrders()
        this.$shipBobStore.dispatch('orders/clearSelectedOrders')
      }
    }, 500),
    goToOrders () {
      this.$router.push({ name: OrdersEnum.Orders })
    }
  },
  filters: {
    formatNumber (num) {
      return num > 1000 ? '1,000+' : num
    },
    determinePlural (text, num) {
      // TODO: will need to run specific logic for other languages
      if (num === 1) return text
      const plural = text + 's'
      return plural
    }
  },
  i18n: {
    messages: {
      'en-US': {
        copyOrders: {
          title: 'Are you sure you want to copy the order(s)?',
          selected: 'selected',
          order: 'order',
          selections: {
            default: 'Default',
            doNotInvoice: 'Do Not Invoice'
          },
          actions: {
            cancel: 'Cancel',
            execute: 'Copy Order'
          }
        }
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import '../../../assets/scss/shipbob-custom/components/orders/_orderAction.scss';
</style>
